import React from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';

const MarkdownContainer = styled.div`
  padding: 1.5rem;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
  line-height: 1.6;
  
  h1, h2, h3, h4, h5, h6 {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    color: #333;
  }
  
  h1 {
    font-size: 2.2rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #eee;
  }
  
  h2 {
    font-size: 1.8rem;
    padding-bottom: 0.3rem;
    border-bottom: 1px solid #eee;
  }
  
  h3 {
    font-size: 1.5rem;
  }
  
  p {
    margin-bottom: 1rem;
    color: #444;
  }
  
  a {
    color: #0066cc;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  ul, ol {
    padding-left: 2rem;
    margin-bottom: 1rem;
  }
  
  li {
    margin-bottom: 0.5rem;
  }
  
  code {
    background: #f5f5f5;
    padding: 0.2rem 0.4rem;
    border-radius: 3px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.9em;
  }
  
  pre {
    background: #f5f5f5;
    padding: 1rem;
    border-radius: 5px;
    overflow-x: auto;
    margin-bottom: 1.5rem;
  }
  
  blockquote {
    border-left: 4px solid #0066cc;
    padding-left: 1.2rem;
    margin-left: 0;
    color: #666;
  }
  
  table {
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 1.5rem;
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
  }
  
  th {
    background-color: #f5f5f5;
    color: #333;
    text-align: left;
  }
  
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  img {
    max-width: 100%;
    height: auto;
    margin: 1rem 0;
    border-radius: 5px;
  }
`;

const MarkdownViewer = ({ content }) => {
  return (
    <MarkdownContainer>
      <ReactMarkdown>{content}</ReactMarkdown>
    </MarkdownContainer>
  );
};

export default MarkdownViewer;
